export default {
  'pay.msg.headerTitle': '消息管理',
  'pay.msg.subtitle.prefix': '消息通知默认保留时长为: ',
  'pay.msg.subtitle.suffix': ' 天',
  'pay.msg.subtitle.action': '设置',
  'pay.msg.button.create': '新建消息',
  'pay.msg.button.batchDelete': '批量删除',
  'pay.msg.button.view': '查看',
  'pay.msg.button.close': '关闭',
  'pay.msg.button.cancel': '取消',
  'pay.msg.button.confirm': '确定',
  'pay.msg.button.delete': '删除',
  'pay.msg.message.saveSuccess': '保存成功',
  'pay.msg.message.selectForDelete': '请选择要删除的消息',
  'pay.msg.message.deleteSuccess': '删除成功',
  'pay.msg.message.deleteError': '删除失败',
  'pay.msg.message.batchDeleteSuccess': '批量删除成功',
  'pay.msg.message.batchDeleteError': '批量删除失败',
  'pay.msg.message.createSuccess': '发送成功',
  'pay.msg.message.updateSuccess': '更新成功',
  'pay.msg.message.createError': '发送失败',
  'pay.msg.message.updateError': '更新失败',
  'pay.msg.message.selectRecipients': '请选择发送对象',
  'pay.msg.error.fetchNoticeTypes': '获取消息类型字典失败',
  'pay.msg.error.fetchTotalUsers': '获取总用户数失败',
  'pay.msg.error.fetchStoreDays': '获取消息保留时长失败',
  'pay.msg.error.fetchList': '获取消息列表失败',
  'pay.msg.error.fetchReadStatus': '获取阅读状态失败',
  'pay.msg.noticeType.system': '系统通知',
  'pay.msg.noticeType.activity': '活动通知',
  'pay.msg.noticeType.urgent': '紧急通知',
  'pay.msg.noticeType.other': '其他',
  'pay.msg.sendType.batch': '批量',
  'pay.msg.sendType.personal': '个人',
  'pay.msg.status.draft': '草稿',
  'pay.msg.status.sent': '已发送',
  'pay.msg.status.scheduled': '定时发送',
  'pay.msg.status.cancelled': '取消',
  'pay.msg.common.unknown': '未知',
  'pay.msg.table.title': '消息标题',
  'pay.msg.table.content': '消息内容',
  'pay.msg.table.type': '消息类型',
  'pay.msg.table.sendType': '发送类型',
  'pay.msg.table.receiverCount': '接收人数',
  'pay.msg.table.status': '状态',
  'pay.msg.table.createdTime': '创建时间',
  'pay.msg.table.action': '操作',
  'pay.msg.popconfirm.deleteTitle': '确定要删除这条消息吗？',
  'pay.msg.popconfirm.deleteDescription': '删除后将无法恢复，请谨慎操作',
  'pay.msg.readStatus.modal.title': '消息阅读状态',
  'pay.msg.readStatus.description.batch': '批量发送的消息仅返回已读的用户数量和列表。',
  'pay.msg.readStatus.description.personal': '个人消息会展示全部接收人员及其阅读状态。',
  'pay.msg.readStatus.column.name': '姓名',
  'pay.msg.readStatus.column.phone': '电话',
  'pay.msg.readStatus.column.isRead': '是否已读',
  'pay.msg.readStatus.column.readTime': '阅读时间',
  'pay.msg.readStatus.value.read': '已读',
  'pay.msg.readStatus.value.unread': '未读',
  'pay.msg.storeDays.modal.title': '设置消息保留时长',
  'pay.msg.storeDays.form.label': '天数',
  'pay.msg.storeDays.form.placeholder': '请输入天数',
  'pay.msg.storeDays.form.required': '请输入天数',
  'pay.msg.details.modal.title': '消息详情',
  'pay.msg.details.section.basic': '基本信息',
  'pay.msg.details.section.time': '时间信息',
  'pay.msg.details.section.system': '系统信息',
  'pay.msg.details.field.content': '消息内容',
  'pay.msg.details.field.type': '消息类型',
  'pay.msg.details.field.sendType': '发送类型',
  'pay.msg.details.field.status': '消息状态',
  'pay.msg.details.field.targets': '发送对象',
  'pay.msg.details.field.receiverCount': '接收人数',
  'pay.msg.details.field.createdTime': '创建时间',
  'pay.msg.details.field.startTime': '发送时间',
  'pay.msg.details.field.endTime': '结束时间',
  'pay.msg.details.field.updatedTime': '更新时间',
  'pay.msg.details.field.remark': '备注',
  'pay.msg.form.section.basic': '基本信息',
  'pay.msg.form.section.status': '状态与时间',
  'pay.msg.form.section.remark': '备注信息',
  'pay.msg.form.title.label': '消息标题',
  'pay.msg.form.title.placeholder': '请输入消息标题',
  'pay.msg.form.title.required': '请输入消息标题',
  'pay.msg.form.title.max': '标题不能超过100个字符',
  'pay.msg.form.content.label': '消息内容',
  'pay.msg.form.content.placeholder': '请输入消息内容',
  'pay.msg.form.content.required': '请输入消息内容',
  'pay.msg.form.content.max': '内容不能超过1000个字符',
  'pay.msg.form.type.label': '消息类型',
  'pay.msg.form.type.placeholder': '请选择消息类型',
  'pay.msg.form.type.required': '请选择消息类型',
  'pay.msg.form.sendType.label': '发送类型',
  'pay.msg.form.sendType.placeholder': '请选择发送类型',
  'pay.msg.form.sendType.required': '请选择发送类型',
  'pay.msg.form.sendType.selectOwner': '选择业主',
  'pay.msg.form.sendType.personalLabel': '发送对象',
  'pay.msg.form.sendType.personalPlaceholder':
    '请输入用户名，多个用户用英文逗号分隔，或点击选择业主',
  'pay.msg.form.sendType.personalExtra':
    '请输入用户名，多个用户用英文逗号分隔，例如：user1,user2,user3，或点击上方按钮选择业主',
  'pay.msg.form.sendType.personal.required': '请输入发送对象',
  'pay.msg.form.sendType.personal.pattern': '请输入有效的用户名，多个用户用英文逗号分隔',
  'pay.msg.form.status.label': '消息状态',
  'pay.msg.form.status.placeholder': '请选择消息状态',
  'pay.msg.form.status.required': '请选择消息状态',
  'pay.msg.form.startTime.label': '发送时间',
  'pay.msg.form.startTime.placeholder': '请选择发送时间',
  'pay.msg.form.startTime.required': '请选择发送时间',
  'pay.msg.form.remark.label': '备注',
  'pay.msg.form.remark.placeholder': '请输入备注信息（可选）',
  'pay.msg.form.remark.max': '备注长度不能超过200个字符',
  'pay.msg.form.ownerModal.title': '选择业主',
  'pay.msg.form.ownerModal.ok': '确认选择',
  'pay.msg.form.ownerModal.cancel': '取消',
  'pay.msg.form.ownerModal.selected': '已选择 {count} 位业主：',
  'pay.msg.form.ownerModal.columns.username': '用户名',
  'pay.msg.form.ownerModal.columns.name': '姓名',
  'pay.msg.form.ownerModal.columns.phone': '手机号',
  'pay.msg.form.ownerModal.columns.email': '邮箱',
  'pay.msg.form.ownerModal.columns.idCard': '身份证号',
  'pay.msg.form.ownerModal.columns.role': '角色',
  'pay.msg.form.ownerModal.columns.status': '状态',
  'pay.msg.form.ownerModal.role.owner': '业主',
  'pay.msg.form.ownerModal.role.tenant': '租户',
  'pay.msg.form.ownerModal.role.visitor': '访客',
  'pay.msg.form.ownerModal.status.active': '正常',
  'pay.msg.form.ownerModal.status.disabled': '禁用',
  'pay.msg.preview.modal.title': '消息详情',
  'pay.msg.preview.section.basic': '基本信息',
  'pay.msg.preview.section.time': '时间信息',
  'pay.msg.preview.section.system': '系统信息',
  'pay.msg.preview.field.title': '消息标题',
  'pay.msg.preview.field.content': '消息内容',
  'pay.msg.preview.field.type': '消息类型',
  'pay.msg.preview.field.sendType': '发送类型',
  'pay.msg.preview.field.status': '消息状态',
  'pay.msg.preview.field.targets': '发送对象',
  'pay.msg.preview.field.startTime': '开始时间',
  'pay.msg.preview.field.endTime': '结束时间',
  'pay.msg.preview.field.createdTime': '创建时间',
  'pay.msg.preview.field.updatedTime': '更新时间',
  'pay.msg.preview.field.remark': '备注',
  'pay.msg.preview.button.close': '关闭',
  'pay.msg.drawer.title.view': '查看消息',
  'pay.msg.drawer.title.create': '新建消息',
  'pay.msg.button.createSubmit': '创建',
  'pay.bill.headerTitle': '账单缴费',
  'pay.bill.subtitle.base': '查看和管理所有待缴费账单',
  'pay.bill.subtitle.current.building': '当前选择：{building}',
  'pay.bill.subtitle.current.buildingFloor': '当前选择：{building} - {floor}',
  'pay.bill.subtitle.current.full': '当前选择：{building} - {floor} - {house}',
  'pay.bill.tree.title': '楼栋楼层房屋选择',
  'pay.bill.tree.floorFallback': '{floor}楼',
  'pay.bill.common.unknown': '未知',
  'pay.bill.error.loadRecentMonths': '加载最近6个月时间列表失败',
  'pay.bill.error.loadTreeData': '加载楼栋楼层房屋数据失败',
  'pay.bill.breadcrumb.pay': '缴费管理',
  'pay.bill.breadcrumb.bill': '账单缴费',
  'pay.bill.table.headerTitle': '待缴费账单列表',
  'pay.bill.table.houseInfo': '房屋信息',
  'pay.bill.table.parkingInfo': '车位信息',
  'pay.bill.table.billName': '账单名称',
  'pay.bill.table.billNo': '账单编号',
  'pay.bill.table.feeType': '费用类型',
  'pay.bill.table.period': '账期',
  'pay.bill.table.ownerName': '业主姓名',
  'pay.bill.table.ownerPhone': '业主手机',
  'pay.bill.table.ownerEmail': '业主邮箱',
  'pay.bill.table.finalAmount': '最终应付金额',
  'pay.bill.table.remainAmount': '剩余金额',
  'pay.bill.table.paymentStatus': '缴费状态',
  'pay.bill.table.dueDate': '到期日期',
  'pay.bill.table.action': '操作',
  'pay.bill.status.unpaid': '未缴费',
  'pay.bill.status.paid': '已缴费',
  'pay.bill.status.overdue': '逾期',
  'pay.bill.status.partial': '部分缴费',
  'pay.bill.status.partial_paid': '部分缴费',
  'pay.bill.status.cancelled': '已取消',
  'pay.bill.filter.unpaid': '待缴费',
  'pay.bill.filter.paid': '已缴费',
  'pay.bill.filter.overdue': '已逾期',
  'pay.bill.filter.partial_paid': '部分支付',
  'pay.bill.filter.cancelled': '已取消',
  'pay.bill.approval.notified': '已通知',
  'pay.bill.message.billIdMissing': '账单ID不存在',
  'pay.bill.message.feeTypeMissing': '费用类型不存在',
  'pay.bill.error.loadStatusOptions': '加载缴费状态字典失败',
  'pay.bill.error.loadApprovalStatus': '加载审核状态字典失败',
  'pay.bill.error.loadFeeTypeOptions': '加载费用类型字典失败',
  'pay.bill.error.loadStatusStats': '加载账单状态统计失败',
  'pay.bill.error.fetchList': '获取待缴费账单列表失败',
  'pay.bill.table.pagination.total': '第 {start}-{end} 条 / 总共 {total} 条',
  'pay.bill.button.pay': '缴费',
  'pay.bill.button.view': '查看',
  'pay.bill.payment.method.cash': '现金',
  'pay.bill.payment.method.wechat': '微信',
  'pay.bill.payment.method.alipay': '支付宝',
  'pay.bill.payment.method.bank': '银行转账',
  'pay.bill.payment.error.loadPaymentMethods': '加载支付方式字典失败',
  'pay.bill.payment.error.unknownFeeType': '未知的费用类型',
  'pay.bill.payment.error.fetchDetail': '获取账单详情失败',
  'pay.bill.payment.error.incomplete': '账单信息不完整',
  'pay.bill.payment.message.success': '缴费处理成功',
  'pay.bill.payment.message.failure': '缴费处理失败',
  'pay.bill.payment.drawerTitle': '{type}缴费处理',
  'pay.bill.payment.section.paymentInfo': '缴费信息',
  'pay.bill.payment.form.statusLabel': '缴费状态',
  'pay.bill.payment.form.statusPlaceholder': '请选择缴费状态',
  'pay.bill.payment.form.statusRequired': '请选择缴费状态',
  'pay.bill.payment.form.methodLabel': '支付方式',
  'pay.bill.payment.form.methodPlaceholder': '请选择支付方式',
  'pay.bill.payment.form.referenceLabel': '支付凭证号',
  'pay.bill.payment.form.referencePlaceholder': '请输入支付凭证号（可选）',
  'pay.bill.payment.form.remarkLabel': '备注',
  'pay.bill.payment.form.remarkPlaceholder': '请输入备注（可选）',
  'pay.bill.button.submit': '提交',
  'pay.bill.payment.button.submit': '提交',
  'pay.bill.payment.button.cancel': '取消',
  'pay.bill.payment.type.generic': '费用',
};
